export default __webpack_public_path__ + "static/scc-bea1495f1d0edc71c1f7ca253de36b2f.jpg";